import React from 'react';
import { ModalShell } from './ui';

interface ConfirmDeleteModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  confirmButtonLabel?: string;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  onConfirm,
  onCancel,
  title = 'Delete Channel',
  message = 'Are you sure you want to delete this channel? This action cannot be undone.',
  confirmButtonLabel = '🗑️ Delete',
}) => {
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onCancel();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);

  return (
    <ModalShell
      title={title}
      onClose={onCancel}
      className="confirm-modal"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={onConfirm}>
            {confirmButtonLabel}
          </button>
        </>
      }
    >
      <p>{message}</p>
    </ModalShell>
  );
};

export default ConfirmDeleteModal;
